
import { isiOS, isDebugger } from '@/utils/functions'

const state = {
    iosUrl: null,   // 微信iOS版无法随history mode改变url，所以需要记录首次进入页面的url
    url: null,      // 当前url
}

const getters = {
    signUrl: state => {

        var url = state.url;
        if (isiOS() && !isDebugger()) {
            url = state.iosUrl.split('#')[0];
        }

        return url;
    }
}

// mutations
const mutations = {
    oldurl: function (state, url) {
        if (isiOS()) {
            if (state.iosUrl == null) {
                state.iosUrl = url;
            }
        }
    }, 
    url: function (state, url) {
        state.url = url;
    }
}

export default {
    namespaced: true,
    state,
    getters,
//    actions,
    mutations
}